import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="250" y="15" rx="4" ry="4" width="100" height="4" />
      <rect x="280" y="35" rx="3" ry="3" width="70" height="4" />
      <rect x="50" y="15" rx="3" ry="3" width="170" height="4" />
      <rect x="50" y="35" rx="3" ry="3" width="170" height="4" />
      <rect x="50" y="55" rx="3" ry="3" width="150" height="4" />
      <rect x="50" y="80" rx="3" ry="3" width="80" height="20" />
      <circle cx="15" cy="25" r="10" />
    </React.Fragment>
  );
};
